module.exports = __webpack_public_path__ + "img/sonido.de6b66cf.svg";